import * as $ from 'jquery';
import {Notif} from "@/js/global/components/Notif";

export const resendEmailAjax = ()=>{
    $('#resend_email_form').on('submit', async function (e) {

        e.preventDefault();
        const $btn = $('.resend-email');
        $btn.attr('disabled', true);

        let valid = true;
        const $email = $("#resend_email");
        const email = $email.val();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            valid = false;
        } else {
            valid = true;
        }

        if (!valid){
            Notif.show('error','Email format is invalid');
            return;
        }

        const action = localizedScript.resend_email_action;


        $.ajax({
            url: localizedScript.ajax_url,
            type: 'POST',
            data: {
                action: action,
                nonce: localizedScript.resend_email_nonce,
                email: email
            },
            success: function (response) {
                console.log(response);
                if(response.success){
                    Notif.show('success',response.data.message);
                }else{
                    Notif.show('error', response.data.message);
                }
                $btn.attr('disabled', false);
            }
        });
    });

}